/** 
 * schema实体类
 * @property entitySets 实体集集合
 * @property entityTypes 实体类型集合
 * @property description schema自描述
 * @author linchang 2018/12/7*/
export class Schema {
  entitySets: EntitySet[] = [];
  entityTypes: EntityType[] = [];
  description: string;
}

/** 
 * 实体类型
 * @property id 唯一标识
 * @property name 语义化名称
 * @property key 主键
 * @property properties 属性列表信息
 * @property navigationProperties 导航属性列表
 * @property description 自描述
 * @author linchang 2018/12/7*/
export class EntityType {
  id: string;
  name: string;
  key: string;
  properties: Property[] = [];
  navigationProperties: NavigationProperty[] = [];
  description: string;
}

/** 
 * 实体集合
 * @property name 实体集名称
 * @property entityType 对应的实体类型名
 * @property description 自描述
 * @author linchang 2018/12/7*/
export class EntitySet {
  name: string;
  entityType: string;
  description: string;
}

/** 
 * 实体类型中的属性
 * @property name 属性名
 * @property type 属性类型
 * @property description 自描述
 * @author linchang 2018/12/7*/
export class Property {
  name: string;
  type: string;
  description: string;
}

/** 
 * 导航属性--关联相对应实体类型或者实体集
 * @property name 导航属性名
 * @property type 导航属性类型
 * @property navigationId 导航值
 * @property description 自描述
 * @author linchang 2018/12/7*/
export class NavigationProperty {
  name: string;
  type: NavigationType;
  navigationId;
  description: string;
}

/** 
 * 关联属性所对应的实体类型
 * @member EntitySet 实体集
 * @member EntityType 实体类型
 * @author linchang 2018/12/7*/
export enum NavigationType {
  EntitySet,
  EntityType,
  EntityEnum
}